import { render, staticRenderFns } from "./novalList.vue?vue&type=template&id=046cf9ab&scoped=true"
import script from "./novalList.vue?vue&type=script&lang=js"
export * from "./novalList.vue?vue&type=script&lang=js"
import style0 from "./novalList.vue?vue&type=style&index=0&id=046cf9ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046cf9ab",
  null
  
)

export default component.exports